const $ = require('jquery/dist/jquery');

const buildRequest = function fn(configuration, instance) {
    if (configuration.session) {
        return JSON.stringify({ SessionCode: configuration.session, [configuration.parameterName]: instance.value });
    }
    return JSON.stringify({ [configuration.parameterName]: instance.value, Source: 900 });
};

const executeAjax = function fn(instance) {
    const configuration = instance.config;

    // Exit in case we dont have the information we need
    if (!(configuration.endpoint && configuration.parameterName && configuration.verb)) return false;

    const verb = configuration.verb.toLowerCase();

    setTimeout(() => {
        let promise;
        if (verb === 'post') {
            promise = $.post({
                url: configuration.endpoint,
                data: buildRequest(configuration, instance),
                contentType: 'application/json; charset=utf-8',
                withCredentials: true
            });
        } else if (verb === 'get') {
            promise = $.get({
                url: configuration.endpoint,
                data: buildRequest(configuration, instance),
                contentType: 'application/json; charset=utf-8',
                withCredentials: true
            });
        }

        if (promise) {
            promise
                .done(() => {
                    window.location.reload(true);
                })
                .fail(() => {
                    console.error('Oooopsss ... An error has occurred to change the origin :(');
                });
        }
    }, 1);

    return true;
};

module.exports = {
    getConfig: function fn() {
        let prototypeConfiguration = {};

        if (this.element) {
            const configuration = this.element.dataset.config;

            if (configuration) {
                prototypeConfiguration = JSON.parse(configuration);
                this.element.dataset.config = '';
            }
        }

        return prototypeConfiguration;
    },
    get: function fn() {
        return this.value || '';
    },
    setCookieAutoOrigin: function fn() {
        if (this.config && this.config.autoOrigin) {
            document.cookie = `${this.config.autoOrigin.ck_name}=${this.config.autoOrigin.ck_value};path=/`;
        }
    },
    onClickOrigin: function fn(e) {
        if (e.target.parentElement === this.element) {
            const newSelectedOrigin = e.target;

            if (newSelectedOrigin === this.selectedOrigin) return false;

            this.setCookieAutoOrigin();

            // --> We have a selected origin?
            if (this.selectedOrigin) {
                // --> Delete current origin to set the new
                this.selectedOrigin.classList.remove(this.config.selectedClass);
                const icon = this.selectedOrigin.lastChild;

                if (icon && icon.nodeName === 'SPAN') {
                    newSelectedOrigin.appendChild(icon);
                }
            }
            // --> Set the new origin
            this.selectedOrigin = newSelectedOrigin;
            this.selectedOrigin.classList.add(this.config.selectedClass);
            this.value = this.selectedOrigin.attributes[this.config.originOption].value;

            // --> Try to set the new origin in session using an API
            executeAjax(this);

            return true;
        }
        return false;
    },
    bindEvents: function bindEvents() {
        this.onClickOrigin = this.onClickOrigin.bind(this);
    },
    addEventListener: function fn() {
        this.bindEvents();
        this.element.addEventListener('click', this.onClickOrigin);

        return this;
    },
    removeEventListener: function fn() {
        this.element.removeEventListener('click', this.onClickOrigin);

        return this;
    },
    initialize: function fn() {
        const selectedOrigin = this.element.querySelector(`.${this.config.selectedClass}`);

        if (!selectedOrigin) return this;

        const checkHasSelected = selectedOrigin.classList.contains(this.config.selectedClass);

        if (checkHasSelected) {
            this.selectedOrigin = selectedOrigin;
            this.value = selectedOrigin.dataset.code;
        }

        this.addEventListener();

        return this;
    }
};
